import { FC } from 'react';
import { PinnedProductsStoryblok } from 'storyblok-types';
import { HeadLine } from 'atoms/Typography/Typography';
import { PinnedSlider } from 'pages/ProductListing/PinnedProducts/PinnedSlider';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import { getCategoryById } from 'commerce/scayle/product-management';
import { getCategoryProductsBackend } from 'commerce/shop/backend';
import styles from './PinnedSlider.module.css';

export const PinnedProducts: FC<
  IStoryBlokComponentProps<PinnedProductsStoryblok>
> = async ({ blok }) => {
  const { response: category, error } = await getCategoryById(
    Number(blok.categoryId),
  );

  if (error || !category?.name) {
    return null;
  }

  const response = await getCategoryProductsBackend({
    categoryName: category.name,
  });

  return !response?.data?.hits?.length ? null : (
    <div
      className={styles.root}
      style={{ backgroundColor: blok.backgroundColor.color }}
    >
      <HeadLine type="sm" color="white" className={styles.title}>
        {blok.title}
      </HeadLine>

      <PinnedSlider products={response.data.hits} />
    </div>
  );
};
